import React from 'react';
import { BrowserRouter as Router, Route, Routes,  Navigate } from 'react-router-dom'
import Home from './pages/home';
import About from './pages/aboutus';
import Clients from './pages/clients';
import Contact from './pages/contact';
import Products from './pages/products';
import Login from './dashboard/login';
import Dashboard from './dashboard/index';
import PrivateRoute from './dashboard/PrivateRoute';

function Routers () {
      return (
        <Router>
          <Routes>
            <Route path="/" exact element={<Home/>}/>
            <Route path="/about-pints" exact element={<About/>}/>
            <Route path="/pints-products" exact element={<Products/>}/>
            <Route path="/Pints-clients" exact element={<Clients/>}/>
            <Route path="/contact-pints" exact element={<Contact/>}/>
            <Route path="/login" exact element={<Login/>}/>
            {/* Protected Route */}
        <Route
          path="/pints-dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />

        {/* Default Redirect to Login */}
        <Route path="*" element={<Navigate to="/login" />} />
            {/* <Route path="/pints-dashboard" exact element={<Dashboard/>}/> */}
        </Routes>
    </Router>
      )
}
    
  
  export default Routers;